import { type Country } from '@entities/country/@/hotel';
import { type Resort } from '@entities/resort/@/hotel';
import { type Hotel } from '../types/Hotel';
import { type RawHotel } from '../types/RawHotel';

export default function (hotels: RawHotel[], countries: Country[], resorts: Resort[]): Hotel[] {
    return hotels.reduce((acc, hotel) => {
        const hotelCountry = countries.find((country) => country.id === hotel.country);
        const hotelResort = resorts.find((resort) => resort.id === hotel.resort);
        if (hotelCountry && hotelResort) {
            acc.push(Object.freeze({
                ...hotel,
                country: hotelCountry,
                resort: hotelResort,
            }));
        }
        return acc;
    }, [] as Hotel[]);
}